import React from "react";
import { AuthBanner } from "../../auth-banner/auth-banner.component";

interface AuthLayoutProps {
	children: React.ReactNode;
	title: string;
	subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
	children,
	title,
	subtitle,
}) => {
	return (
		<div className="flex min-h-screen flex-col bg-gray-50">
			<AuthBanner />
			<div className="flex flex-1 items-center justify-center py-12 px-4">
				<div className="w-full max-w-md bg-white p-8 lg:p-10 rounded-lg shadow-xl border border-gray-200">
					{title && (
						<div className="text-center mb-6">
							<h1 className="text-2xl font-bold tracking-tight text-gray-900">
								{title}
							</h1>
							{subtitle && (
								<p className="text-gray-600 mt-2">{subtitle}</p>
							)}
						</div>
					)}
					{children}
				</div>
			</div>
		</div>
	);
};
